import axios from "axios";
import {
  FINANCIAL_LIST_REQUEST,
  FINANCIAL_LIST_SUCCESS,
  FINANCIAL_LIST_FAIL,
} from "../constants/financialConstants";
import { api2 } from "../core/api";

export const getfinancial = () => async (dispatch) => {
  try {
    dispatch({
      type: FINANCIAL_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await api2.get("/financialsource", config);

    var dt = data.Result;

    if (typeof dt === "string") {
      dispatch({
        type: FINANCIAL_LIST_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: FINANCIAL_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: FINANCIAL_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
